module.exports = __webpack_public_path__ + "1bb12f4f/img/SOURCERY_poweredby_web.9819842b.png";